<template>
  <li class="fl">
    <div>{{data.DateModify}}</div>
    <div>
      <select v-model="data.CallStatus">
        <option :value="status.name" v-for="status in callStatusList">{{status.name}}</option>
      </select>
    </div>
    <div>
      <select v-model="data.SubCallStatus">
        <option :value="subStatus.name" v-for="subStatus in subCallStatusList">{{subStatus.name}}</option>
      </select>
    </div>
    <div>
      <select v-model="data.WhereToFindUs">
        <option :value="wtf.nameOption" v-for="wtf in wtfList">{{wtf.nameOption}}</option>
      </select>
    </div>
    <div>{{data.Phone}}</div>
    <div>{{data.FIOAgent}}</div>
    <div class="button" v-on:click="Set_IncomingCallData">Сохранить</div>
  </li>
</template>

<script>
  import statusListLib from '@/gavnoCode/statusList';
  import DataForInput from '@/gavnoCode/longFormOptions';

    export default {
    name: "editLeadIncome",
    props:{
      data:Object,
    },
    data(){
      return {
        callStatusList:[],
        wtfList: DataForInput.WHERE_TO_FIND_US.selectOption
      }
    },
    methods:{
      Set_IncomingCallData(){
        this.$myApi.SendRequest(
          {
            Guid:this.data.IncCallGUID,
            CallStatus :this.data.CallStatus,
            SubCallStatus :this.data.SubCallStatus,
            WhereToFindUs :this.data.WhereToFindUs,
            action: 'Operator_Set_IncomingCallData'
          },
          this,
          'Set_IncomingCallData',
          true
        )
          .then((res)=>{this.$store.commit('setContent', res);})
          .catch((res)=>{console.log(res);this.$store.commit('setContent', 'Ошибка сохранения');});
      }
    },
    computed:{
      subCallStatusList(){
        let out = [];

        let subStatusObj = statusListLib.StatusListIncoming.find((element)=>{
          return element.name == this.data.CallStatus;
        });
        if (subStatusObj.subStatus !== undefined) {
          out = Object.assign([],subStatusObj.subStatus)
        }
        out.push({name: this.data.SubCallStatus},{name:''});

        return out;
      },
    },
    mounted(){
      this.callStatusList = Object.assign([],statusListLib.StatusListIncoming);
      this.callStatusList.push({name: this.data.CallStatus});

      // childStatus = statusListLib.StatusListIncoming.

    }
  }
</script>

<style scoped>
div{display: flex;align-items: center;justify-content: center}

</style>
